export const PATH_PATIENTS = 'patients';
export const PATH_PATIENTS_LIST = 'list';
export const PATH_PATIENT_DASHBOARD = 'dashboard';
export const PATH_CREATE_PATIENT = 'create-patient';
export const PATH_EDIT_PATIENT = 'edit-patient';

export const PATH_ROLE_PARAM = 'role';
export const PATH_ID_PARAM = 'id';
